export default {
  TOGGLE_LOADING: Symbol('TOGGLE_LOADING'),
  UPDATE_STATE: Symbol('UPDATE_STATE'),
  HOTEL_CHANNEL_LIST: Symbol('HOTEL_CHANNEL_LIST'),
  CHANNEL_INFO_LIST: Symbol('CHANNEL_INFO_LIST'),
  HOTEL_ROOM_TYPE_LIST: Symbol('HOTEL_ROOM_TYPE_LIST'),
  CRS_ROOM_QUANTITY_LIST: Symbol('CRS_ROOM_QUANTITY_LIST'),
  SET_DATE_RANGE_INDEX: Symbol('SET_DATE_RANGE_INDEX'),
  SET_DATE_RANGE_OPTION: Symbol('SET_DATE_RANGE_OPTION'),
  UPDATE_FILTER_PARAMS: Symbol('UPDATE_FILTER_PARMS'),
  SET_ENROLLED_LIST: Symbol('ENROLLED_LIST'),
  RESET_ENROLLED_DATA: Symbol('RESET_ENROLLED_DATA'),
  CALC_LOADING: Symbol('CALC_LOADING'),
};
